export class HorizontalCard {
  label: string;
  topicName: string;
  indicatorDescription: string;
  indicatorUrl: string;
  imageUrl: string;
  descriptionText: string;
  sidepanelText: string;
}
